
import React from 'react';

import Standardsplaste from './Standardsplaste';
import Mostcountries from './Mostcountries';
import Chooseyourpallet from './Chooseyourpallet';


const Whatstandardspla = () => {
    return (
        <div>
            <Standardsplaste />
            <Mostcountries />
            <Chooseyourpallet />

        </div>
    );
};

export default Whatstandardspla;
